import axios from "axios";
import { api, weblink } from "./helper";
// import router from "../../router";
import CryptoJS from 'crypto-js';
import Utils from "@/project/Source/utils.js";

const client = axios.create({
  baseURL: api,
  withCredentials: false,
});

client.interceptors.request.use((config) => {
  const rawJwt = window.localStorage.getItem("jwt");
  if (rawJwt) {
    try {
      const token = JSON.parse(
        CryptoJS.AES.decrypt(rawJwt, "secret_key").toString(CryptoJS.enc.Utf8)
      );
      config.headers.Authorization = "Bearer " + token;
    } catch (e) {
      // First login or a broken stored token should not block the request.
    }
  }
  return config;
});

client.interceptors.response.use(
  (response) => {
    if (response.data && response.data.isSuccess === false) {
      const isLogin = (response.config?.url || "").includes("SystemAuth/Login");
      if (!isLogin && response.data.errors && response.data.errors[0]) {
        Utils.Alert(response.data.errors[0]);
      }
    }
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      if (!window.location.pathname.toLowerCase().includes("signin")) {
        window.location.href = weblink + "signIn";
      }
    } else if (error.response && error.response.data && error.response.data.errors) {
      Utils.Alert(error.response.data.errors);
    }
    return Promise.reject(error);
  }
);

// Claim START

















function PolicyCardByCard(item) {
  return client.post("Policy/PolicyCardByCard", item);
}
function PolicyCardCount(item) {
  return client.post("Policy/PolicyCardCount", item);
}
function PolicyCardByPage(item) {
  return client.post("Policy/PolicyCardByPage", item);
}
function MedicalPolicyByCompany(item) {
  return client.post("Policy/MedicalPolicyByCompany", item);
}
function Groups(item) {
  return client.post("Policy/Groups", item);
}
function PolicyCardCancelRequest(item) {
  return client.post("Policy/PolicyCardCancelRequest", item);
}
function PolicyCardGroupChangeRequest(item) {
  return client.post("Policy/PolicyCardGroupChangeRequest", item);
}
function PolicyCardDataChangeRequest(item) {
  return client.post("Policy/PolicyCardDataChangeRequest", item);
}
function Policy(item) {
  return client.post("Policy/Policy", item);
}
function ClaimAnalitics(item) {
  return client.post("Policy/ClaimAnalitics", item);
}
function AccountRequestByCard(item) {
  return client.post("Policy/AccountRequestByCard", item);
}
function DropAccountRequestRequest(item) {
  return client.post("Policy/DropAccountRequestRequest", item);
}
function AccountRequestByPolicy(item) {
  return client.post("Policy/AccountRequestByPolicy", item);
}
function ReferralAnalitics(item) {
  return client.post("Policy/ReferralAnalitics", item);
}
function PolicyClinics(item) {
  return client.post("Policy/PolicyClinics", item);
}
function AccountRequestCountByPolicy(item) {
  return client.post("Policy/AccountRequestCountByPolicy", item);
}
function AccountStatusAnalitics(item) {
  return client.post("Policy/AccountStatusAnalitics", item);
}
function AccountOperAnalitics(item) {
  return client.post("Policy/AccountOperAnalitics", item);
}
function AccountRequestByPolicyAll(item) {
  return client.post("Policy/AccountRequestByPolicyAll", item);
}
function PolicyCardAnalitic(item) {
  return client.post("Policy/PolicyCardAnalitic", item);
}
function PolicyNewCardAnalitic(item) {
  return client.post("Policy/PolicyNewCardAnalitic", item);
}
function Files(item) {
  return client.post("File/Files", item);
}
function AccountRequestCount(item) {
  return client.post("Policy/AccountRequestCount", item);
}
function PolicyClinicsAnalitics(item) {
  return client.post("Policy/PolicyClinicsAnalitics", item);
}
function AccountRequestById(item) {
  return client.post("Policy/AccountRequestById", item);
}
function NotifTypes(item) {
  return client.post("Policy/NotifTypes", item);
}
function Notifications(item) {
  return client.post("Policy/Notifications", item);
}
function PolicyInsuredDependants(item) {
  return client.post("Policy/PolicyInsuredDependants", item);
}
function DropFilesRequest(item) {
  return client.post("File/DropFilesRequest", item);
}
function PolicyAllInsuredDependants(item) {
  return client.post("Policy/PolicyAllInsuredDependants", item);
}
function AppointmentRequests(item) {
  return client.post("Policy/AppointmentRequests", item);
}
function CheckJwt(item) {
  return client.post("SystemAuth/CheckJwt", item);
}
function Login(item) {
  return client.post("SystemAuth/Login", item);
}
function PolicyCardImportRequest(item) {
  return client.post("Policy/PolicyCardImportRequest", item);
}
function PolicyCardActive(item) {
  return client.post("Policy/PolicyCardActive", item);
}
function NewPolicyInsuredDependantRequest(item) {
  return client.post("Policy/NewPolicyInsuredDependantRequest", item);
}
function DropPolicyInsuredDependantRequest(item) {
  return client.post("Policy/DropPolicyInsuredDependantRequest", item);
}
function ChangePassword(item) {
  return client.post("SystemAuth/ChangePassword", item);
}
function AccountRequestsBulkByPolicy(item) {
  return client.post("Policy/AccountRequestsBulkByPolicy", item);
}
function AccountRequestBulkItems(item) {
  return client.post("Policy/AccountRequestBulkItems", item);
}
function AccountRequestsBulkCountByPolicy(item) {
  return client.post("Policy/AccountRequestsBulkCountByPolicy", item);
}
function AccountRequestBulkInsert(item) {
  return client.post("Policy/AccountRequestBulkInsert", item);
}
function AccountRequestBulkDelete(item) {
  return client.post("Policy/AccountRequestBulkDelete", {
    requestCorrelationId: "string",
    ...item,
  });
}

//Client Service Zbt End

export default {
  ChangePassword,
  PolicyClinics,
  AppointmentRequests,
  PolicyInsuredDependants,
  Notifications,
  Login,
  PolicyAllInsuredDependants,
  DropFilesRequest,
  CheckJwt,
  AccountRequestCount,
  PolicyClinicsAnalitics,
  AccountRequestById,
  Files,
  NotifTypes,
  PolicyNewCardAnalitic,
  PolicyCardAnalitic,
  AccountRequestByCard,
  AccountStatusAnalitics,
  AccountOperAnalitics,
  AccountRequestByPolicyAll,
  AccountRequestCountByPolicy,
  ReferralAnalitics,
  AccountRequestByPolicy,
  PolicyCardCount,
  DropAccountRequestRequest,
  ClaimAnalitics,
  Policy,
  PolicyCardByPage,
  MedicalPolicyByCompany,
  PolicyCardByCard,
  Groups,
  PolicyCardCancelRequest,
  PolicyCardGroupChangeRequest,
  PolicyCardDataChangeRequest,
  PolicyCardImportRequest,
  PolicyCardActive,
  NewPolicyInsuredDependantRequest,
  DropPolicyInsuredDependantRequest,
  AccountRequestsBulkByPolicy,
  AccountRequestBulkItems,
  AccountRequestsBulkCountByPolicy,
  AccountRequestBulkInsert,
  AccountRequestBulkDelete
};
